import { useState } from 'react';
import { Button, Modal, Select, Typography, message } from 'antd';
import APIClient from '../api/api';

// Accounts offered in the export dropdown. Only paritysoftwareultra is wired up
// for now; add more as other accounts need the same export.
const ACCOUNT_OPTIONS = [{ label: 'paritysoftwareultra', value: 'paritysoftwareultra' }];

function saveTextFile(filename: string, content: string) {
  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export default function FastTransfer() {
  const [modalOpen, setModalOpen] = useState(false);
  const [account, setAccount] = useState(ACCOUNT_OPTIONS[0].value);
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const resp = await APIClient.getVerifiedNotActiveFastTransfer(account);
      const domains = [...resp.domains].sort((a, b) => a.localeCompare(b));
      if (domains.length === 0) {
        message.info('No verified but not-active domains for this account.');
        return;
      }
      saveTextFile(`fast-transfer-verified-not-active-${account}.txt`, domains.join('\n') + '\n');
      message.success(`Downloaded ${domains.length} domain${domains.length === 1 ? '' : 's'}.`);
      setModalOpen(false);
    } catch {
      message.error('Failed to fetch domains.');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Typography.Title level={3}>Fast Transfer</Typography.Title>
      <Typography.Paragraph type="secondary">
        Export the domains whose registrant verification is registrar-confirmed but which are
        not yet fast-transfer active, to hand to the marketplace rep for activation. The list
        is limited to fast-transfer-eligible TLDs.
      </Typography.Paragraph>
      <Button type="primary" onClick={() => setModalOpen(true)}>
        Download verified not-active domains
      </Button>
      <Modal
        title="Download verified not-active domains"
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        onOk={handleDownload}
        okText="Download"
        confirmLoading={downloading}
      >
        <Typography.Paragraph style={{ marginBottom: 8 }}>Account</Typography.Paragraph>
        <Select
          style={{ width: '100%' }}
          value={account}
          onChange={setAccount}
          options={ACCOUNT_OPTIONS}
          aria-label="Account"
        />
        <Typography.Paragraph type="secondary" style={{ marginTop: 16, marginBottom: 0 }}>
          Downloads a newline-separated, alphabetical list of domains as a .txt file.
        </Typography.Paragraph>
      </Modal>
    </div>
  );
}
